export enum CSATTypes {
  once = 'once',
  multitime = 'multitime',
}
